import { Box, Flex, Grid, Heading, Text } from "@chakra-ui/react"
import { ReactNode } from "react"

interface ContentProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}

const Content = ({ title, description, actions, children }: ContentProps) => (
  <Box p={title ? { base: '4', lg: '6' } : { base: '1', lg: '5' }} minW='0'>
    {title && (
      <Grid as='header' templateColumns={{ base: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr)' }} alignItems='center' gap='4' mb='6'>
        <Box minW='0' gridColumn={{ base: 1, md: 2 }} textAlign='center'>
          <Heading as='h1' size={{ base: '2xl', lg: '3xl' }} hyphens='auto'>{title}</Heading>
          {description && <Text color='fg.muted' mt='2'>{description}</Text>}
        </Box>
        {actions && (
          <Flex gap='2' wrap='wrap' gridColumn={{ base: 1, md: 3 }} justify={{ base: 'center', md: 'flex-end' }}
            css={{ '& > button': { whiteSpace: 'normal', h: 'auto', minH: '10', py: '2', maxW: 'full' } }}>
            {actions}
          </Flex>
        )}
      </Grid>
    )}
    {children}
  </Box>
)

export default Content
